import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTitle } from '../../hooks/use-title.js';
import { CenterLayout } from '../page-layout/index.js';

export const SiteTitle: FC = () => {
  const title = useTitle();
  return (
    <CenterLayout>
      <Typography component="div" noWrap variant="h6">
        {title ?? 'Patrol Roster'}
      </Typography>
    </CenterLayout>
  );
};
